/*
 * Javascript to show and hide cookie bar using localstorage
 */

/**
 * @description Shows the cookie bar
 */
function showCookieBar() {
  let cookieBar = document.getElementById("cookie-bar");
  if (cookieBar) {
    cookieBar.style.display = "block";
  }
}

/**
 * @description Hides the Cookie bar and saves the value to localstorage
 */
function hideCookieBar() {
  localStorage.setItem("isCookieAccepteds", "yes");

  let cookieBar = document.getElementById("cookie-bar");
  if (cookieBar) {
    cookieBar.style.display = "none";
  }
}

/**
 * @description Checks the localstorage and shows Cookie bar based on it.
 */
function initializeCookieBar() {
  let isCookieAccepted = localStorage.getItem("isCookieAccepteds");

  if (isCookieAccepted === null) {
    localStorage.setItem("isCookieAccepteds", "no");
    showCookieBar();
  } else if (isCookieAccepted === "no") {
    showCookieBar();
  }
}

// Bind load handler to DOMContentLoaded so the element exists before running
document.addEventListener("DOMContentLoaded", initializeCookieBar);

// Assigning values to window object
document.cb_hideCookieBar = hideCookieBar;